import { AchievementBadge } from "../../ui/achievement-card";
import "./achievements.scss";
import { useGetAchievementsQuery } from "../../data-access/store/services/badges.service";
import { useAppSelector } from "../../../hooks/hooks";
import { selectUser } from "../../../auth/data-access/store/authSlice";
import { AchievementsResponse } from "../../../shared/interfaces/general.types";
import { selectLanguage } from "../../../shared/data-access/store/general/generalSlice";
import { format } from "date-fns";
import useAmbientSound from "../../../utils/hooks/use-ambient-sound";

export function AchievementsPage() {
  const { data: achievementsData } = useGetAchievementsQuery();
  const user = useAppSelector(selectUser);
  const lang = useAppSelector(selectLanguage);

  const userAchievements = user?.character?.achievements || [];

  useAmbientSound("home");

  const renderAchievements = (achievements: AchievementsResponse["items"]) => {
    return achievements?.map((achievement) => {
      const unlocked = Array.isArray(userAchievements)
        ? userAchievements.find(
            (userAchievement) => userAchievement.id === achievement.id
          )
        : null;

      let unlockDate = "";

      if (unlocked) {
        const dateStr = unlocked?.unlockDate;
        const [dateValues] = dateStr.split(" ");
        const date = new Date(dateValues);
        unlockDate = format(new Date(date), "d MMM, yyyy");
      }

      return (
        <AchievementBadge
          key={achievement.id}
          badgeType={unlocked ? "unlocked" : "locked"}
          badge={achievement.image}
          subtitle={unlockDate || ""}
          description={achievement.description[lang]}
        >
          {achievement.name[lang]}
        </AchievementBadge>
      );
    });
  };

  return (
    <div className="badges-container">
      <div className="badges-content">
        <div className="achievement-container">
          {achievementsData && achievementsData.items
            ? renderAchievements(achievementsData.items)
            : null}
        </div>
      </div>
    </div>
  );
}

export default AchievementsPage;
